import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelEdit,
  isValidSupplier,
  save,
  selectors as supplierSelectors,
  selectEditedSupplierId,
  selectEditedSupplierIsNew,
  selectSupplierEditOpen,
  selectSupplierIsSaving,
} from "../redux/suppliers";
import ModalScreen from "./ModalScreen";

const EditSupplierForm = (props) => {
  const dispatch = useDispatch();

  const supplier = useSelector((state) =>
    supplierSelectors.selectById(state, selectEditedSupplierId(state)),
  );

  const isSaving = useSelector(selectSupplierIsSaving);

  const [name, setName] = useState(supplier?.name || "");

  const supplierToSave = { name };

  const isValid = isValidSupplier(supplierToSave);

  const nameHelperText = name && !isValid ? "min 3 characters" : "";

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  const onSave = () => {
    const isEdited = name !== supplier?.name;
    if (isEdited) {
      dispatch(save(supplierToSave));
    } else {
      dispatch(cancelEdit());
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12}>
        <TextField
          autoFocus
          fullWidth
          helperText={nameHelperText}
          label="Name"
          onChange={onNameChange}
          placeholder="Supplier Name (min 3 characters)"
          required
          value={name}
        />
      </Grid>
      <Grid xs={12}>
        <Button
          className={isSaving ? "InProgress" : ""}
          fullWidth
          disabled={!isValid || isSaving}
          onClick={onSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </Grid>
    </Grid>
  );
};

const EditSupplier = (props) => {
  const dispatch = useDispatch();
  const onClose = () => dispatch(cancelEdit());
  const open = useSelector(selectSupplierEditOpen);
  const isNewSupplier = useSelector(selectEditedSupplierIsNew);
  const title = isNewSupplier ? "Add New Supplier" : "Edit Supplier";

  return (
    <ModalScreen open={open} onClose={onClose} title={title}>
      <EditSupplierForm onClose={onClose} />
    </ModalScreen>
  );
};

export default EditSupplier;
